import { Box, Typography, Button, Container } from '@mui/material';
import CareersFeatures from './CareersFeatures';

export default function Careers() {
  return (
    <Box sx={{ bgcolor: '#050505', color: '#fff' }}>

      {/* ================= HERO SECTION ================= */}
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          background: 'linear-gradient(135deg, #000000 0%, #000000 50%, #000000 100%)',
          py: { xs: 6, sm: 8, md: 0 },
        }}
      >
        <Container maxWidth="md">
          <Typography
            variant="h2"
            sx={{
              fontWeight: 800,
              mb: { xs: 2, sm: 3, md: 4 },
              lineHeight: 1.1,
              fontSize: { xs: '2rem', sm: '3rem', md: '4rem' },
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            Build the Future with AI
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: '#bbb',
              mb: { xs: 3, sm: 4, md: 5 },
              maxWidth: { xs: '100%', sm: '80%', md: '600px' },
              fontSize: { xs: '0.9rem', sm: '1rem', md: '1.2rem' },
              textAlign: { xs: 'center', md: 'left' },
              mx: { xs: 'auto', md: 0 },
            }}
          >
            Join a mission-driven team working on cutting-edge technology with real-world impact.
          </Typography>

          <Box
            sx={{
              display: 'flex',
              gap: 2,
              flexWrap: { xs: 'wrap', sm: 'wrap', md: 'nowrap' },
              justifyContent: { xs: 'center', md: 'flex-start' },
            }}
          >
            {/* Scroll to Open Roles */}
            <Button
              variant="contained"
              size="large"
              onClick={() => {
                document.getElementById('open-roles')?.scrollIntoView({ behavior: 'smooth' });
              }}
              sx={{
                bgcolor: '#64ffda',
                color: '#000',
                fontWeight: 600,
                px: { xs: 3, sm: 4 },
                py: { xs: 1.5, sm: 2 },
                fontSize: { xs: '0.85rem', sm: '1rem' },
                '&:hover': { bgcolor: '#52e0c4' },
              }}
            >
              View Open Roles
            </Button>

            {/* Scroll to Life at Company */}
            <Button
              variant="outlined"
              size="large"
              onClick={() => {
                document.getElementById('life-at-company')?.scrollIntoView({ behavior: 'smooth' });
              }}
              sx={{
                color: '#fff',
                borderColor: '#555',
                px: { xs: 3, sm: 4 },
                py: { xs: 1.5, sm: 2 },
                fontSize: { xs: '0.85rem', sm: '1rem' },
                '&:hover': { borderColor: '#fff' },
              }}
            >
              Life at Our Company
            </Button>
          </Box>
        </Container>
      </Box>

      <Box id="life-at-company" >
        <CareersFeatures  />
      </Box>
       
      <Box id="open-roles"></Box>
    </Box >
  );
}
